import {
  Checkbox,
  FormControl,
  InputLabel,
  FormHelperText,
} from '@mui/material';

export default function CheckboxField({
  input,
  meta,
  label,
  disabled,
  className,
}) {
  return (
    <FormControl className={className} error={meta.touched && meta.invalid}>
      <InputLabel style={{ marginTop: 6 }} shrink={true}>
        {label}
      </InputLabel>
      <Checkbox
        checked={Boolean(input.value)}
        onChange={(event) => input.onChange(event.target.checked)}
        style={{
          marginLeft: 10,
          marginTop: 8,
          width: 24,
        }}
        disabled={Boolean(disabled)}
      />
      <FormHelperText>{meta.touched && meta.error}</FormHelperText>
    </FormControl>
  );
}
